export default __webpack_public_path__ + "static/media/brand-img.42c062b0.svg";